import * as Mod1 from "./discourse/adapters/discourse-post-event-adapter";
import * as Mod2 from "./discourse/adapters/discourse-post-event-event";
import * as Mod3 from "./discourse/adapters/discourse-post-event-invitee";
import * as Mod4 from "./discourse/adapters/discourse-post-event-nested-adapter";
import * as Mod5 from "./discourse/adapters/discourse-post-event-reminder";
import * as Mod6 from "./discourse/admin-calendar-route-map";
import * as Mod7 from "./discourse/api-initializers/discourse-group-timezones";
import * as Mod8 from "./discourse/components/admin-holidays-list-item";
import * as Mod9 from "./discourse/components/admin-holidays-list";
import * as Mod10 from "./discourse/components/bulk-invite-sample-csv-file";
import * as Mod11 from "./discourse/components/calendar-placeholder";
import * as Mod12 from "./discourse/components/category-calendar";
import * as Mod13 from "./discourse/components/compact-event-editor";
import * as Mod14 from "./discourse/components/composer-event-editor";
import * as Mod15 from "./discourse/components/csv-uploader";
import * as Mod16 from "./discourse/components/discourse-post-event/calendar-prompt";
import * as Mod17 from "./discourse/components/discourse-post-event/chat-channel";
import * as Mod18 from "./discourse/components/discourse-post-event/creator";
import * as Mod19 from "./discourse/components/discourse-post-event/dates";
import * as Mod20 from "./discourse/components/discourse-post-event/description";
import * as Mod21 from "./discourse/components/discourse-post-event/event-status";
import * as Mod22 from "./discourse/components/discourse-post-event/image";
import * as Mod23 from "./discourse/components/discourse-post-event/index";
import * as Mod24 from "./discourse/components/discourse-post-event/invitee";
import * as Mod25 from "./discourse/components/discourse-post-event/invitees";
import * as Mod26 from "./discourse/components/discourse-post-event/livestream";
import * as Mod27 from "./discourse/components/discourse-post-event/location";
import * as Mod28 from "./discourse/components/discourse-post-event/more-menu";
import * as Mod29 from "./discourse/components/discourse-post-event/onebox-node-view";
import * as Mod30 from "./discourse/components/discourse-post-event/onebox-preview";
import * as Mod31 from "./discourse/components/discourse-post-event/status";
import * as Mod32 from "./discourse/components/discourse-post-event/url";
import * as Mod33 from "./discourse/components/event-date";
import * as Mod34 from "./discourse/components/event-node-view";
import * as Mod35 from "./discourse/components/full-calendar";
import * as Mod36 from "./discourse/components/group-timezones/index";
import * as Mod37 from "./discourse/components/group-timezones/new-day";
import * as Mod38 from "./discourse/components/group-timezones/time-traveller";
import * as Mod39 from "./discourse/components/group-timezones/timezone";
import * as Mod40 from "./discourse/components/livestream/embeddable-chat-channel";
import * as Mod41 from "./discourse/components/livestream/mobile-livestream-chat-icon";
import * as Mod42 from "./discourse/components/livestream/modal/mobile-embeddable-chat-modal";
import * as Mod43 from "./discourse/components/livestream/responsive-livestream-chat-icon";
import * as Mod44 from "./discourse/components/livestream/zoom-entry";
import * as Mod45 from "./discourse/components/livestream/zoom-page";
import * as Mod46 from "./discourse/components/modal/post-event-builder";
import * as Mod47 from "./discourse/components/modal/post-event-bulk-invite";
import * as Mod48 from "./discourse/components/modal/post-event-invite-user-or-group";
import * as Mod49 from "./discourse/components/modal/post-event-invitees/index";
import * as Mod50 from "./discourse/components/modal/post-event-invitees/user";
import * as Mod51 from "./discourse/components/post-calendar";
import * as Mod52 from "./discourse/components/region-input";
import * as Mod53 from "./discourse/components/toggle-invitees";
import * as Mod54 from "./discourse/components/upcoming-events-calendar";
import * as Mod55 from "./discourse/components/upcoming-events-list";
import * as Mod56 from "./discourse/connectors/before-main-outlet/embeddable-chat-channel-connector.gjs";
import * as Mod57 from "./discourse/connectors/before-topic-list-body/category-calendar.gjs";
import * as Mod58 from "./discourse/connectors/calendar-preferences/discourse-events-preferences.gjs";
import * as Mod59 from "./discourse/connectors/calendar-subscriptions-feeds/event-feeds.gjs";
import * as Mod60 from "./discourse/connectors/category-custom-settings/show-event-category-sorting-settings.gjs";
import * as Mod61 from "./discourse/connectors/chat-channel-card-cta/livestream-rsvp.gjs";
import * as Mod62 from "./discourse/connectors/chat-channel-preview-card-content/livestream-rsvp.gjs";
import * as Mod63 from "./discourse/connectors/discovery-list-container-top/category-events-calendar.gjs";
import * as Mod64 from "./discourse/connectors/header-topic-title-suffix/event-date-container.gjs";
import * as Mod65 from "./discourse/connectors/topic-list-after-title/event-badge.gjs";
import * as Mod66 from "./discourse/connectors/user-custom-preferences/region.gjs";
import * as Mod67 from "./discourse/controllers/admin-plugins/show/discourse-events-holidays";
import * as Mod68 from "./discourse/controllers/discourse-post-event-upcoming-events";
import * as Mod69 from "./discourse/controllers/discourse-post-event-upcoming-events/index";
import * as Mod70 from "./discourse/controllers/discourse-post-event-upcoming-events/mine";
import * as Mod71 from "./discourse/discourse-calendar-topic-zoom-route-map";
import * as Mod72 from "./discourse/discourse-event-upcoming-events-route-map";
import * as Mod73 from "./discourse/helpers/format-event-name";
import * as Mod74 from "./discourse/helpers/format-future-date";
import * as Mod75 from "./discourse/initializers/add-create-event-composer-action";
import * as Mod76 from "./discourse/initializers/add-event-ui-builder";
import * as Mod77 from "./discourse/initializers/add-events-create-topic-button";
import * as Mod78 from "./discourse/initializers/add-upcoming-events-to-sidebar";
import * as Mod79 from "./discourse/initializers/calendar-admin-plugin-configuration-nav";
import * as Mod80 from "./discourse/initializers/disable-sort";
import * as Mod81 from "./discourse/initializers/discourse-calendar";
import * as Mod82 from "./discourse/initializers/discourse-post-event-decorator";
import * as Mod83 from "./discourse/initializers/event-relative-date";
import * as Mod84 from "./discourse/initializers/event-user-options";
import * as Mod85 from "./discourse/initializers/livestream-chat-overrides";
import * as Mod86 from "./discourse/lib/add-event-to-calendar";
import * as Mod87 from "./discourse/lib/calendar-locale";
import * as Mod88 from "./discourse/lib/calendar-view-helper";
import * as Mod89 from "./discourse/lib/colors";
import * as Mod90 from "./discourse/lib/constants";
import * as Mod91 from "./discourse/lib/discourse-markdown/discourse-calendar";
import * as Mod92 from "./discourse/lib/discourse-markdown/discourse-post-event-block";
import * as Mod93 from "./discourse/lib/discourse-markdown/livestream-preview";
import * as Mod94 from "./discourse/lib/event-preview";
import * as Mod95 from "./discourse/lib/event-recurrence";
import * as Mod96 from "./discourse/lib/event-relative-date";
import * as Mod97 from "./discourse/lib/format-event-for-calendar";
import * as Mod98 from "./discourse/lib/full-calendar-default-options";
import * as Mod99 from "./discourse/lib/guess-best-date-format";
import * as Mod100 from "./discourse/lib/livestream-rsvp";
import * as Mod101 from "./discourse/lib/livestream-utils";
import * as Mod102 from "./discourse/lib/open-event-composer";
import * as Mod103 from "./discourse/lib/raw-event-helper";
import * as Mod104 from "./discourse/lib/regions";
import * as Mod105 from "./discourse/lib/round-time";
import * as Mod106 from "./discourse/lib/zoom-frame-url";
import * as Mod107 from "./discourse/models/discourse-post-event-event-stats";
import * as Mod108 from "./discourse/models/discourse-post-event-event";
import * as Mod109 from "./discourse/models/discourse-post-event-invitee";
import * as Mod110 from "./discourse/models/discourse-post-event-invitees";
import * as Mod111 from "./discourse/models/discourse-post-event-reminder";
import * as Mod112 from "./discourse/modifiers/dismiss-keyboard-on-chat-send";
import * as Mod113 from "./discourse/modifiers/open-links-in-new-tab";
import * as Mod114 from "./discourse/modifiers/zoom-page-viewport-fit";
import * as Mod115 from "./discourse/pre-initializers/rich-editor-extension";
import * as Mod116 from "./discourse/pre-initializers/transformers";
import * as Mod117 from "./discourse/routes/discourse-post-event-upcoming-events";
import * as Mod118 from "./discourse/routes/discourse-post-event-upcoming-events/default-index";
import * as Mod119 from "./discourse/routes/discourse-post-event-upcoming-events/default-mine";
import * as Mod120 from "./discourse/routes/discourse-post-event-upcoming-events/index";
import * as Mod121 from "./discourse/routes/discourse-post-event-upcoming-events/mine";
import * as Mod122 from "./discourse/routes/topic-zoom";
import * as Mod123 from "./discourse/services/create-event-composer";
import * as Mod124 from "./discourse/services/discourse-post-event-api";
import * as Mod125 from "./discourse/services/discourse-post-event-service";
import * as Mod126 from "./discourse/services/embeddable-chat";
import * as Mod127 from "./discourse/services/post-calendar";
import * as Mod128 from "./discourse/templates/admin-plugins/show/discourse-events-holidays";
import * as Mod129 from "./discourse/templates/discourse-post-event-upcoming-events";
import * as Mod130 from "./discourse/templates/discourse-post-event-upcoming-events/index";
import * as Mod131 from "./discourse/templates/discourse-post-event-upcoming-events/mine";
import * as Mod132 from "./discourse/templates/topic-zoom";
const compatModules = {
  "discourse/adapters/discourse-post-event-adapter": Mod1,
  "discourse/adapters/discourse-post-event-event": Mod2,
  "discourse/adapters/discourse-post-event-invitee": Mod3,
  "discourse/adapters/discourse-post-event-nested-adapter": Mod4,
  "discourse/adapters/discourse-post-event-reminder": Mod5,
  "discourse/admin-calendar-route-map": Mod6,
  "discourse/api-initializers/discourse-group-timezones": Mod7,
  "discourse/components/admin-holidays-list-item": Mod8,
  "discourse/components/admin-holidays-list": Mod9,
  "discourse/components/bulk-invite-sample-csv-file": Mod10,
  "discourse/components/calendar-placeholder": Mod11,
  "discourse/components/category-calendar": Mod12,
  "discourse/components/compact-event-editor": Mod13,
  "discourse/components/composer-event-editor": Mod14,
  "discourse/components/csv-uploader": Mod15,
  "discourse/components/discourse-post-event/calendar-prompt": Mod16,
  "discourse/components/discourse-post-event/chat-channel": Mod17,
  "discourse/components/discourse-post-event/creator": Mod18,
  "discourse/components/discourse-post-event/dates": Mod19,
  "discourse/components/discourse-post-event/description": Mod20,
  "discourse/components/discourse-post-event/event-status": Mod21,
  "discourse/components/discourse-post-event/image": Mod22,
  "discourse/components/discourse-post-event/index": Mod23,
  "discourse/components/discourse-post-event/invitee": Mod24,
  "discourse/components/discourse-post-event/invitees": Mod25,
  "discourse/components/discourse-post-event/livestream": Mod26,
  "discourse/components/discourse-post-event/location": Mod27,
  "discourse/components/discourse-post-event/more-menu": Mod28,
  "discourse/components/discourse-post-event/onebox-node-view": Mod29,
  "discourse/components/discourse-post-event/onebox-preview": Mod30,
  "discourse/components/discourse-post-event/status": Mod31,
  "discourse/components/discourse-post-event/url": Mod32,
  "discourse/components/event-date": Mod33,
  "discourse/components/event-node-view": Mod34,
  "discourse/components/full-calendar": Mod35,
  "discourse/components/group-timezones/index": Mod36,
  "discourse/components/group-timezones/new-day": Mod37,
  "discourse/components/group-timezones/time-traveller": Mod38,
  "discourse/components/group-timezones/timezone": Mod39,
  "discourse/components/livestream/embeddable-chat-channel": Mod40,
  "discourse/components/livestream/mobile-livestream-chat-icon": Mod41,
  "discourse/components/livestream/modal/mobile-embeddable-chat-modal": Mod42,
  "discourse/components/livestream/responsive-livestream-chat-icon": Mod43,
  "discourse/components/livestream/zoom-entry": Mod44,
  "discourse/components/livestream/zoom-page": Mod45,
  "discourse/components/modal/post-event-builder": Mod46,
  "discourse/components/modal/post-event-bulk-invite": Mod47,
  "discourse/components/modal/post-event-invite-user-or-group": Mod48,
  "discourse/components/modal/post-event-invitees/index": Mod49,
  "discourse/components/modal/post-event-invitees/user": Mod50,
  "discourse/components/post-calendar": Mod51,
  "discourse/components/region-input": Mod52,
  "discourse/components/toggle-invitees": Mod53,
  "discourse/components/upcoming-events-calendar": Mod54,
  "discourse/components/upcoming-events-list": Mod55,
  "discourse/connectors/before-main-outlet/embeddable-chat-channel-connector": Mod56,
  "discourse/connectors/before-topic-list-body/category-calendar": Mod57,
  "discourse/connectors/calendar-preferences/discourse-events-preferences": Mod58,
  "discourse/connectors/calendar-subscriptions-feeds/event-feeds": Mod59,
  "discourse/connectors/category-custom-settings/show-event-category-sorting-settings": Mod60,
  "discourse/connectors/chat-channel-card-cta/livestream-rsvp": Mod61,
  "discourse/connectors/chat-channel-preview-card-content/livestream-rsvp": Mod62,
  "discourse/connectors/discovery-list-container-top/category-events-calendar": Mod63,
  "discourse/connectors/header-topic-title-suffix/event-date-container": Mod64,
  "discourse/connectors/topic-list-after-title/event-badge": Mod65,
  "discourse/connectors/user-custom-preferences/region": Mod66,
  "discourse/controllers/admin-plugins/show/discourse-events-holidays": Mod67,
  "discourse/controllers/discourse-post-event-upcoming-events": Mod68,
  "discourse/controllers/discourse-post-event-upcoming-events/index": Mod69,
  "discourse/controllers/discourse-post-event-upcoming-events/mine": Mod70,
  "discourse/discourse-calendar-topic-zoom-route-map": Mod71,
  "discourse/discourse-event-upcoming-events-route-map": Mod72,
  "discourse/helpers/format-event-name": Mod73,
  "discourse/helpers/format-future-date": Mod74,
  "discourse/initializers/add-create-event-composer-action": Mod75,
  "discourse/initializers/add-event-ui-builder": Mod76,
  "discourse/initializers/add-events-create-topic-button": Mod77,
  "discourse/initializers/add-upcoming-events-to-sidebar": Mod78,
  "discourse/initializers/calendar-admin-plugin-configuration-nav": Mod79,
  "discourse/initializers/disable-sort": Mod80,
  "discourse/initializers/discourse-calendar": Mod81,
  "discourse/initializers/discourse-post-event-decorator": Mod82,
  "discourse/initializers/event-relative-date": Mod83,
  "discourse/initializers/event-user-options": Mod84,
  "discourse/initializers/livestream-chat-overrides": Mod85,
  "discourse/lib/add-event-to-calendar": Mod86,
  "discourse/lib/calendar-locale": Mod87,
  "discourse/lib/calendar-view-helper": Mod88,
  "discourse/lib/colors": Mod89,
  "discourse/lib/constants": Mod90,
  "discourse/lib/discourse-markdown/discourse-calendar": Mod91,
  "discourse/lib/discourse-markdown/discourse-post-event-block": Mod92,
  "discourse/lib/discourse-markdown/livestream-preview": Mod93,
  "discourse/lib/event-preview": Mod94,
  "discourse/lib/event-recurrence": Mod95,
  "discourse/lib/event-relative-date": Mod96,
  "discourse/lib/format-event-for-calendar": Mod97,
  "discourse/lib/full-calendar-default-options": Mod98,
  "discourse/lib/guess-best-date-format": Mod99,
  "discourse/lib/livestream-rsvp": Mod100,
  "discourse/lib/livestream-utils": Mod101,
  "discourse/lib/open-event-composer": Mod102,
  "discourse/lib/raw-event-helper": Mod103,
  "discourse/lib/regions": Mod104,
  "discourse/lib/round-time": Mod105,
  "discourse/lib/zoom-frame-url": Mod106,
  "discourse/models/discourse-post-event-event-stats": Mod107,
  "discourse/models/discourse-post-event-event": Mod108,
  "discourse/models/discourse-post-event-invitee": Mod109,
  "discourse/models/discourse-post-event-invitees": Mod110,
  "discourse/models/discourse-post-event-reminder": Mod111,
  "discourse/modifiers/dismiss-keyboard-on-chat-send": Mod112,
  "discourse/modifiers/open-links-in-new-tab": Mod113,
  "discourse/modifiers/zoom-page-viewport-fit": Mod114,
  "discourse/pre-initializers/rich-editor-extension": Mod115,
  "discourse/pre-initializers/transformers": Mod116,
  "discourse/routes/discourse-post-event-upcoming-events": Mod117,
  "discourse/routes/discourse-post-event-upcoming-events/default-index": Mod118,
  "discourse/routes/discourse-post-event-upcoming-events/default-mine": Mod119,
  "discourse/routes/discourse-post-event-upcoming-events/index": Mod120,
  "discourse/routes/discourse-post-event-upcoming-events/mine": Mod121,
  "discourse/routes/topic-zoom": Mod122,
  "discourse/services/create-event-composer": Mod123,
  "discourse/services/discourse-post-event-api": Mod124,
  "discourse/services/discourse-post-event-service": Mod125,
  "discourse/services/embeddable-chat": Mod126,
  "discourse/services/post-calendar": Mod127,
  "discourse/templates/admin-plugins/show/discourse-events-holidays": Mod128,
  "discourse/templates/discourse-post-event-upcoming-events": Mod129,
  "discourse/templates/discourse-post-event-upcoming-events/index": Mod130,
  "discourse/templates/discourse-post-event-upcoming-events/mine": Mod131,
  "discourse/templates/topic-zoom": Mod132,
};
export { compatModules };
export default compatModules;
